import React from 'react';
import { pathOr } from 'ramda'

class OutcomeLearnerCards extends React.Component {

  render() {

    let outcomes = [
      'become more aware of their own strengths and areas for growth',
      'undertake challenges that develop new skills',
      'discuss, evaluate and plan student-initiated activities',
      'persevere in action',
      'work collaboratively with others',
      'develop international-mindedness through global engagement, multilingualism and intercultural understanding',
      'consider the ethical implications of their actions'
    ]
    let { t, learningOutcomes } = this.props

    if (learningOutcomes) {
      console.log('learningOutcomes', learningOutcomes);
      let max = Math.max(...Object.values(learningOutcomes).map( item => item.count ? item.count : 0))

      return (
        outcomes.map((item) => {
          return (
            <div style={styles.cardContainer}>
              <div style={styles.projectCard}>
                <div style={styles.label}>
                  {item}
                </div>
              </div>
              <div style={{ backgroundColor: '#4990E2', minWidth: 20, marginLeft: '-10px', display: 'flex', alignItems: 'center', paddingLeft: 5, width: pathOr(0, [item, 'count'], learningOutcomes)  * (450/max), height: '50px', borderRadius: '5px', position: 'relative' }}>
                <div style={styles.value}>
                  {pathOr(0, [item, 'count'], learningOutcomes)}
                </div>
              </div>
            </div>
          )
        })
      )
    } else {
      return (<div>Loading</div>)
    }

  }
}

export default OutcomeLearnerCards;

const styles = {
  cardContainer: {
    marginLeft: '25px',
    marginRight: '25px',
    marginBottom: '25px',
    marginTop: '25px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  projectCard: {
    width: '397px',
    height: '93px',
    color: '#006588',
    fontSize: '14px',
    fontWeight: '800',
    backgroundColor: 'rgba(92,173,228,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    paddingRight: '20px',
    paddingLeft: '20px'
  },

  label: {
    fontSize: '12px',
    fontWeight: '600',
    fontFamily: 'Muli',
    textTransform: 'uppercase',
    color: '#485465',
    display: 'flex',
    alignItems: 'left'
  },

  value: {
    fontSize: '16px',
    color: 'white',
  }
}



// WEBPACK FOOTER //
// ./src/components/OutcomeLearnerCards/index.jsx